import { ChangeDetectionStrategy, Component } from '@angular/core';


@Component({
  selector: 'app-management-reports',
  template: '<app-reports-view category="Management"></app-reports-view>',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManagementReportsComponent {
  constructor() { }
}
